
/*
 * Simple event emitter.  This is intended to manage lifecyle events.
 * E.g., CHILD_REMOVED
 * not thread safe
 */
class EventEmitter {
  constructor() {
    this.callbacks = {};
  }

  on(event, fn) {
    if (!this.getListeners(event).includes(fn)) {
      this.getListeners(event).push(fn);
    }
  }

  once(event, fn) {
    const self = this;
    function on(...args) {
      self.off(event, on);
      fn.apply(this, args);
    }
    this.on(event, on);
  }

  off(event, fn) {
    const index = this.getListeners(event).indexOf(fn);
    if (index !== -1) {
      this.getListeners(event).splice(index, 1);
    }
  }

  offAll() {
    this.callbacks = {};
  }

  emit(event, ...args) {
    this.getListeners(event).forEach((fn) => {
      fn.apply(this, args);
    });
  }

  getListeners(event) {
    this.callbacks[event] = this.callbacks[event] || [];
    return this.callbacks[event];
  }

  hasListeners(event) {
    return !!this.getListeners(event).length;
  }
}

export default EventEmitter;
